module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.5@core-js/library/modules/_is-object.js
// module id = 146
// module chunks = 16